<app-data-mapping-source-or-destination-selector
  [data]="data"
  (handleSelectionChange)="onSelectionChange($event)">
</app-data-mapping-source-or-destination-selector>
